import { render, staticRenderFns } from "./AddGoodReceive.vue?vue&type=template&id=71779b8f&scoped=true&"
import script from "./AddGoodReceive.vue?vue&type=script&lang=js&"
export * from "./AddGoodReceive.vue?vue&type=script&lang=js&"
import style0 from "./AddGoodReceive.vue?vue&type=style&index=0&id=71779b8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71779b8f",
  null
  
)

export default component.exports